import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

/** Selected row id kept in the URL (?sel=…), so a link opens the same row. Replace-navigation. */
export function useSelection(param = 'sel'): [string | null, (id: string | null) => void] {
  const [params, setParams] = useSearchParams()
  const value = params.get(param)
  const set = useCallback(
    (id: string | null) =>
      setParams((p) => {
        const next = new URLSearchParams(p)
        if (id === null) next.delete(param)
        else next.set(param, id)
        return next
      }, { replace: true }),
    [param, setParams],
  )
  return [value, set]
}
